import { render, staticRenderFns } from "./SfTopBar.vue?vue&type=template&id=e98f79fc&"
import script from "./SfTopBar.vue?vue&type=script&lang=js&"
export * from "./SfTopBar.vue?vue&type=script&lang=js&"
import style0 from "./SfTopBar.vue?vue&type=style&index=0&id=e98f79fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports